angular.module('routes.cases.widgets.WidgetsController', [
  'stack'
])

/**
 * The WidgetsController manages view logic rendered to the
 * case.html template for the /case view.
 *
 * @class WidgetsController
 * @constructor
 * @module routes.cases.widgets.WidgetsController
 */
.controller('WidgetsController', [
  '$scope',
  '$state',
  'constants',
  'CasesService',
  'StatesService',
  'WidgetsService',
  function ($scope, $state, constants, CasesService, StatesService, WidgetsService) {
    'use strict';

    // TODO: Get options from schema
    $scope.widgetTypes = ['default', 'sbar', 'student notes'];

    $scope.constants = null;

    $scope.form = {
      template: null,
      schema: null,
      form: null,
      model: {
        content: {
          type: 'default'
        }
      }
    };

    $scope.state = $state;

    /**
     * Saves a widget model provided by the current content
     */
    $scope.saveModel = function saveModel() {
      var model = WidgetsService
        .populateModel($scope.widgets.current, $scope.currentContent.getModel());
      console.log('saveModel', $scope.currentContent.getModel());
      console.log('model', model);
      WidgetsService
        .update(model, $scope)
        .then(function (response) {
          $state.go('routes.cases.states.widgets', { widgetId: response.id, widgetMode: null });
          return;
        })
        .catch(function (err) {
          console.log(err);
        });
    };

    /**
     * Creates a new widget model
     */
    $scope.newWidget = function newWidget() {
      var newWidgetItem = {
        label: $scope.form.model.label,
        content: {
          type: $scope.form.model.content.type,
          collection: [],
          media: []
        }
      };
      WidgetsService
        .create(newWidgetItem, $scope)
        .then(function (response) {
          $state.go(
            'routes.cases.states.widgets',
            { widgetId: response.id, widgetMode: null },
            { reload: true }
          );
          return;
        })
        .catch(function (err) {
          console.log(err);
        });
    };

    /**
     * UI trigger for deleting a Widget
     *
     * @param {string} widgetId - Widget identifier
     */
    $scope.deleteWidget = function deleteWidget(widgetId) {
      CasesService
        .removeRelative($scope.cases.current, widgetId)
        .then(function () {
          return StatesService.removeWidget($scope.states.current, widgetId);
        })
        .then(function () {
          $scope.updateList();
          $state.go('routes.cases.states', { widgetId: null, widgetMode: null }, { reload: true });
          return;
        })
        .catch(function (err) {
          console.log(err);
        });
    };

    /**
     * Method copies resolved constants into the controller
     * namespace during the initalization process.
     *
     * @private
     */
    function defineConstants() {
      $scope.constants = constants.constants;
    }

    /**
     * Defines the current state
     */
    function defineCurrentWidget() {
      if ($state.params.widgetId && $state.params.widgetId !== 'events') {
        $scope.widgets.current = WidgetsService.get($state.params.widgetId);
        $scope.widgets.formatted = WidgetsService.get($state.params.widgetId, true);

        $scope.$on('can-save', function (event, data) {
          $scope.disableSave = data.canSave;
        });
      } else {
        $scope.widgets.current = null;
      }
    }

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      defineConstants();
      defineCurrentWidget();
    }
    initialize();
  }
]);
